import React from 'react';
import {useLocation} from 'react-router-dom';

import {text} from '../text';
import {hooks} from '../hooks';
import {custom} from '../custom';
import {svg} from '../assets/svg';
import {theme} from '../constants';
import {components} from '../components';
import {useLanguage} from '../context/LanguageContext';
import axios from 'axios';

export const ForgotPassword: React.FC = () => {
  const {pathname} = useLocation();
  const navigate = hooks.useAppNavigate();
  const {t} = useLanguage();
  const fp = (t as any).forgotPassword;

  const [email, setEmail] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState('');
  const [sent, setSent] = React.useState(false);

  React.useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0), 10);
  }, [pathname]);

  const handleSubmit = async () => {
    const trimmed = email.trim();
    if (!trimmed) {
      setError(t.common.required);
      return;
    }
    try {
      setIsLoading(true);
      setError('');
      const apiBase = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
      await axios.post(`${apiBase}/auth/forgot-password`, {email: trimmed});
      setSent(true);
    } catch (err: any) {
      setError(err.response?.data?.message || t.common.error);
    } finally {
      setIsLoading(false);
    }
  };

  const renderBackground = (): JSX.Element => <components.Background />;

  const renderHeader = () => (
    <components.Header title={fp?.title || 'Forgot Password'} goBack={true} />
  );

  const renderContent = () => {
    if (sent) {
      return (
        <main style={{padding: '30px 20px 20px 20px', marginTop: 52}}>
          <div style={{textAlign: 'center', marginBottom: 24}}>
            <div style={{fontSize: 48, marginBottom: 12}}>✓</div>
            <text.H2 style={{marginBottom: 12, color: theme.colors.mainColor}}>
              {fp?.successTitle || 'Link Sent!'}
            </text.H2>
            <text.T16 style={{color: theme.colors.textColor, lineHeight: 1.5}}>
              {fp?.successMessage}
            </text.T16>
          </div>
          <components.Button
            title={fp?.backToLogin || 'Back to Login'}
            onClick={() => navigate('/SignIn')}
          />
        </main>
      );
    }

    return (
      <main style={{padding: '30px 20px 20px 20px', marginTop: 52}}>
        <text.T16 style={{marginBottom: 24, color: theme.colors.textColor, lineHeight: 1.5}}>
          {fp?.subtitle}
        </text.T16>
        {error ? (
          <div
            style={{
              backgroundColor: '#FFE0E0',
              color: '#C00000',
              padding: '10px 15px',
              borderRadius: 8,
              marginBottom: 14,
              fontSize: 14,
            }}
          >
            {error}
          </div>
        ) : null}
        <custom.InputField
          type='email'
          value={email}
          onChange={(e: any) => setEmail(e.target.value)}
          leftIcon={<svg.EmailSvg />}
          placeholder={fp?.emailPlaceholder || 'your@email.com'}
          containerStyle={{marginBottom: 14}}
        />
        <components.Button
          title={isLoading ? (fp?.sending || 'Sending...') : (fp?.send || 'Send Reset Link')}
          onClick={handleSubmit}
        />
      </main>
    );
  };

  return (
    <div id='screen'>
      {renderBackground()}
      {renderHeader()}
      {renderContent()}
    </div>
  );
};
